import {
  BLUE_BANNER_ACCENT,
  bannerSurfaces,
} from "@/components/molecules/FancyBanner/FancyBanner";
import { cn } from "@/lib/utils";
import { useTranslation } from "@repo/shared/i18n";
import { Link } from "react-router";

import { AppWaitlistForm } from "./AppWaitlistForm";

const SURFACES = bannerSurfaces(BLUE_BANNER_ACCENT);

/** The menu's app waitlist card, in the slot Wings Cup uses while it runs. */
export const AppPromoNavCard = ({
  onNavigate,
  className,
}: {
  onNavigate: () => void;
  className?: string;
}) => {
  const { t } = useTranslation("appLanding");

  return (
    <aside
      style={{ ...SURFACES.vars, ...SURFACES.panel }}
      className={cn(
        "relative overflow-hidden rounded-2xl border border-[rgba(var(--banner-base),.3)] p-6",
        className,
      )}
    >
      <div
        aria-hidden
        className="pointer-events-none absolute inset-0"
        style={SURFACES.dotField}
      />
      <div className="relative flex flex-col gap-4">
        <div className="flex flex-col items-start gap-3">
          <span className="rounded-full bg-primary-action/12 px-3 py-1.5 text-xs font-semibold uppercase tracking-[.06em] text-primary-washed-blue">
            {t("hero.eyebrow")}
          </span>
          <Link
            to="/app"
            onClick={onNavigate}
            className="text-2xl font-bold leading-tight text-neutral-50 hover:underline"
          >
            {t("hero.title")}
          </Link>
          <p className="text-sm text-neutral-300">{t("promo.navSubtitle")}</p>
        </div>
        <AppWaitlistForm form="nav" />
      </div>
    </aside>
  );
};
